<p class="rfq-info-dialog-title heading-h6-regular">{{title}}</p>
<mat-dialog-content class="rfq-info-dialog-content">
    <p *ngIf="message">{{message}}</p>
    <div class="list-message-container" *ngIf="messages && messages.length > 0">
        <span *ngFor="let item of messages">{{item}}</span>
    </div>
    <div class="form-inputs rfq-info-dialog-content-select" *ngIf="selection?.display">
        <p class="label">{{selection!.title}}</p>
        <ng-select [items]="selection!.selection" bindLabel="Name" bindValue="Id" appearance="outline"
            [(ngModel)]="selectedId" placeholder="Please select an option" />
    </div>
    <div *ngIf="type == rfqInfoDialogType.abort">
        <p class="label paragraph-medium-regular">{{abortLabel}}</p>
        <mat-form-field class="abort-input-container" appearance="outline">
            <input 
                class="abort-input"
                matInput
                [formControl]="abortControl"
            >
          </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="rfq-info-dialog-footer" align="end">
    <app-button class="mar-r-10 large-button" [name]="closeLabel" (click)="handleClose()" />
    <app-button class="large-button submit-button" name="Submit" type="flat-button" *ngIf="displaySubmit" (click)="!isSubmitDisabled && handleClose(true)"
        [disabled]="isSubmitDisabled" [class.btn-abort]="type == rfqInfoDialogType.abort" />
</mat-dialog-actions>